(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-accordion-01"] && !Shopify.designMode) return;
  try {
    
  class YGAccordion01 extends HTMLElement {
    #sectionEl;

    constructor() {
      super();
      this.currentStepIndex = 0;
      this.mobileSwiper = null;
      this.handleDropdownOpen = this.handleDropdownOpen.bind(this);
      this.handleProgressEnd = this.handleProgressEnd.bind(this);
      this.handleMobileSlideChange = this.handleMobileSlideChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this.#sectionEl) return this.#sectionEl;
      this.#sectionEl = {
        accordionList: this.querySelectorAll('.yg-process-steps-item'),
        progressBars: this.querySelectorAll('.yg-process-steps-progress-bar'),
        desktopControls: this.querySelectorAll('.yg-process-steps-media'),
        mobileControls: this.querySelectorAll('.yg-process-steps-content-media'),
        mobileSwiperElement: this.querySelector('.yg-accordion-mobile-swiper'),
        mobileSwiperSlides: this.querySelectorAll('.yg-accordion-mobile-slide')
      };

      return this.#sectionEl;
    }

    get isMobileSwiperMode() {
      return window.innerWidth <= 699 && this.dataset.mobileSwiperEnabled === 'true';
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', this.handleDropdownOpen);
      document.addEventListener('YG:progress-end', this.handleProgressEnd);
      window.addEventListener('resize', this.handleResize);
      this.bindMobileSwiper();

      if (this.isMobileSwiperMode) {
        this.pauseAccordionVideos();
        this.playMobileSwiperVideo();
      }
    }

    disconnectedCallback() {
      document.removeEventListener('YG:dropdown-open', this.handleDropdownOpen);
      document.removeEventListener('YG:progress-end', this.handleProgressEnd);
      window.removeEventListener('resize', this.handleResize);
      this.unbindMobileSwiper();
      this.pauseAllVideos();
    }

    bindMobileSwiper(retryCount = 12) {
      if (this.dataset.mobileSwiperEnabled !== 'true') {
        return;
      }

      const swiper = this.sectionElements.mobileSwiperElement?.swiper;

      if (!swiper) {
        if (retryCount > 0) {
          window.setTimeout(() => this.bindMobileSwiper(retryCount - 1), 120);
        }
        return;
      }

      if (this.mobileSwiper === swiper) {
        return;
      }

      this.unbindMobileSwiper();
      this.mobileSwiper = swiper;
      this.mobileSwiper.on('slideChange', this.handleMobileSlideChange);
      this.handleMobileSlideChange();
    }

    unbindMobileSwiper() {
      if (this.mobileSwiper?.off) {
        this.mobileSwiper.off('slideChange', this.handleMobileSlideChange);
      }

      this.mobileSwiper = null;
    }

    handleDropdownOpen(event) {
      const id = event.detail?.id;

      if (this.isMobileSwiperMode || !id) {
        return;
      }

      this.currentStep(id);
    }

    handleProgressEnd(event) {
      const id = event.detail?.id;

      if (this.isMobileSwiperMode || !id) {
        return;
      }

      this.nextStep(id);
    }

    handleMobileSlideChange() {
      if (!this.isMobileSwiperMode || !this.mobileSwiper) {
        return;
      }

      this.currentStepIndex = typeof this.mobileSwiper.realIndex === 'number'
        ? this.mobileSwiper.realIndex
        : this.mobileSwiper.activeIndex;

      this.playMobileSwiperVideo(this.currentStepIndex);
    }

    handleResize() {
      if (this.isMobileSwiperMode) {
        this.bindMobileSwiper();
        this.pauseAccordionVideos();
        this.playMobileSwiperVideo();
        return;
      }

      this.pauseMobileSwiperVideos();
    }

    nextStep(id) {
      this.sectionElements.accordionList.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.sectionElements.accordionList.length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });

      if (!this.isCurrentStep(id)) {
        return;
      }
      this.sectionElements.accordionList[this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.sectionElements.accordionList.forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    getEffectiveId(id) {
      let isMobile = window.innerWidth <= 699;
      if (isMobile) {
        return id.replace('steps-item-', 'steps-item-mobile-');
      }
      return id;
    }

    setActiveControl(id) {
      this.sectionElements.desktopControls.forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.sectionElements.progressBars?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      const controlGroups = [...this.sectionElements.desktopControls, ...this.sectionElements.mobileControls];

      controlGroups.forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAccordionVideos() {
      const controlGroups = [...this.sectionElements.desktopControls, ...this.sectionElements.mobileControls];

      controlGroups.forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl && typeof videoEl.pauseVideo === 'function') {
          videoEl.pauseVideo();
        }
      });
    }

    pauseMobileSwiperVideos() {
      this.sectionElements.mobileSwiperSlides.forEach((slide) => {
        const videoEl = slide.querySelector('yg-video');
        if (videoEl && typeof videoEl.pauseVideo === 'function') {
          videoEl.pauseVideo();
        }
      });
    }

    pauseAllVideos() {
      this.pauseAccordionVideos();
      this.pauseMobileSwiperVideos();
    }

    playVideo(id) {
      let effectiveId = this.getEffectiveId(id);
      this.pauseAccordionVideos();
      const videoEl = this.getVideoById(effectiveId);
      if (videoEl && typeof videoEl.playVideo === 'function') {
        videoEl.playVideo();
      }
    }

    playMobileSwiperVideo(index) {
      if (!this.isMobileSwiperMode) {
        return;
      }

      const activeIndex = typeof index === 'number'
        ? index
        : typeof this.mobileSwiper?.realIndex === 'number'
          ? this.mobileSwiper.realIndex
          : this.mobileSwiper?.activeIndex || 0;

      this.pauseMobileSwiperVideos();

      const videoEl = this.sectionElements.mobileSwiperSlides[activeIndex]?.querySelector('yg-video');
      if (videoEl && typeof videoEl.playVideo === 'function') {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-accordion-01')) {
    window.customElements.define('yg-accordion-01', YGAccordion01);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps-v1"] && !Shopify.designMode) return;
  try {
    
  class YGProcessSteps extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'accordionList': this.querySelectorAll('.yg-process-steps-item'),
        'progressBars': this.querySelectorAll('.yg-process-steps-progress-bar'),
        'controls': this.querySelectorAll('.yg-process-steps-media')
      }

      return this.#sectionEl
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', (event) => {
        if (event.detail.id) {
          this.currentStep(event.detail.id);
        }
      });
      document.addEventListener('YG:progress-end', (event) => {
        if (event.detail.id) {
          this.nextStep(event.detail.id);
        }
      });
    }

    nextStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });
      
      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    pauseAllVideos() {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl) {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      this.pauseAllVideos();
      const videoEl = this.getVideoById(id);
      if (videoEl) {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-process-steps')) {
    window.customElements.define('yg-process-steps', YGProcessSteps);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-sticky-story-v1"] && !Shopify.designMode) return;
  try {
    
  class YGStickyStoryV1 extends HTMLElement {
    constructor() {
      super();
      this.handleIntersection = this.handleIntersection.bind(this);
    }

    connectedCallback() {
      this.screens = Array.from(this.querySelectorAll('[data-screen]'));

      if (this.screens.length === 0) {
        return;
      }

      this.observer = new IntersectionObserver(this.handleIntersection, {
        threshold: [0.2, 0.4, 0.6, 0.8],
      });

      this.screens.forEach((screen) => {
        this.observer.observe(screen);
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    handleIntersection() {
      if (!this.screens || this.screens.length === 0) {
        return;
      }

      let activeScreen = this.screens[0];
      let highestRatio = -1;

      this.screens.forEach((screen) => {
        const rect = screen.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
        const ratio = Math.max(0, Math.min(visibleHeight / Math.max(rect.height, 1), 1));

        if (ratio > highestRatio) {
          highestRatio = ratio;
          activeScreen = screen;
        }
      });

      this.screens.forEach((screen) => {
        screen.classList.toggle('is-active', screen === activeScreen);
      });
    }
  }

  if (!window.customElements.get('yg-sticky-story-v1')) {
    window.customElements.define('yg-sticky-story-v1', YGStickyStoryV1);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-03"] && !Shopify.designMode) return;
  try {
    
    class YGTabs03 extends HTMLElement {
      constructor() {
        super();
        this.activeIndex = 0;
        this.mediaSwiper = null;
        this.contentSwiper = null;
        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleTabKeydown = this.handleTabKeydown.bind(this);
        this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
        this.handleResize = this.handleResize.bind(this);
      }

      get sectionElements() {
        if (this._sectionElements) {
          return this._sectionElements;
        }

        this._sectionElements = {
          tabsTrack: this.querySelector('[data-tabs-track]'),
          tabsScrollContainer: this.querySelector('[data-tabs-scroll]'),
          tabs: Array.from(this.querySelectorAll('.yg-tabs-03__tab')),
          mediaSwiper: this.querySelector('[data-media-swiper]'),
          contentSwiper: this.querySelector('[data-content-swiper]'),
          contentSlides: Array.from(this.querySelectorAll('.yg-tabs-03__content-slide')),
        };

        return this._sectionElements;
      }

      connectedCallback() {
        if (this.initialized) {
          return;
        }

        this.initialized = true;

        this.sectionElements.tabs.forEach((tab) => {
          tab.addEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
        window.addEventListener('resize', this.handleResize);

        this.mountSwipers();
      }

      disconnectedCallback() {
        this.sectionElements.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
        window.removeEventListener('resize', this.handleResize);

        if (this.mediaSwiper) {
          this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
          this.mediaSwiper = null;
        }

        if (this.contentSwiper) {
          this.contentSwiper = null;
        }

        this.initialized = false;
      }

      mountSwipers(attempt = 0) {
        const mediaSwiperElement = this.sectionElements.mediaSwiper;
        const contentSwiperElement = this.sectionElements.contentSwiper;

        if (!mediaSwiperElement || !contentSwiperElement) {
          return;
        }

        if (!mediaSwiperElement.swiper || !contentSwiperElement.swiper) {
          if (attempt < 10) {
            window.setTimeout(() => this.mountSwipers(attempt + 1), 150);
          }
          return;
        }

        if (!this.mediaSwiper) {
          this.mediaSwiper = mediaSwiperElement.swiper;
          this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
        }

        if (!this.contentSwiper) {
          this.contentSwiper = contentSwiperElement.swiper;
        }

        this.mediaSwiper.allowTouchMove = this.sectionElements.contentSlides.length > 1;
        this.mediaSwiper.params.allowTouchMove = this.sectionElements.contentSlides.length > 1;
        this.contentSwiper.allowTouchMove = false;
        this.contentSwiper.params.allowTouchMove = false;
        this.contentSwiper.params.autoHeight = true;

        this.setActiveState(0, {
          syncSwiper: false,
          scrollBehavior: 'auto',
        });
      }

      handleTabClick(event) {
        const tab = event.currentTarget;
        const index = Number(tab.dataset.tabIndex);

        this.setActiveState(index);
      }

      handleTabKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          return;
        }

        const currentIndex = this.activeIndex;
        const lastIndex = this.sectionElements.tabs.length - 1;
        let nextIndex = currentIndex;

        if (event.key == 'ArrowLeft') {
          nextIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
        } else if (event.key == 'ArrowRight') {
          nextIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
        } else if (event.key == 'Home') {
          nextIndex = 0;
        } else if (event.key == 'End') {
          nextIndex = lastIndex;
        }

        event.preventDefault();

        const nextTab = this.sectionElements.tabs[nextIndex];
        if (nextTab) {
          nextTab.focus();
        }

        this.setActiveState(nextIndex);
      }

      handleMediaSlideChange() {
        const nextIndex = typeof this.mediaSwiper.realIndex === 'number'
          ? this.mediaSwiper.realIndex
          : this.mediaSwiper.activeIndex;

        if (this.contentSwiper && this.contentSwiper.activeIndex !== nextIndex) {
          this.contentSwiper.slideTo(nextIndex);
        }

        this.setActiveState(nextIndex, {
          syncSwiper: false,
        });
      }

      handleResize() {
        this.updateOverflowState();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView('auto');
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }

      isTabsOverflowing() {
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollContainer) {
          return false;
        }

        return scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;
      }

      scrollActiveTabIntoView(behavior = 'smooth') {
        const scrollContainer = this.sectionElements.tabsScrollContainer;
        const activeTab = this.sectionElements.tabs[this.activeIndex];

        if (!activeTab || !scrollContainer) {
          return;
        }

        if (this.isTabsOverflowing()) {
          const containerRect = scrollContainer.getBoundingClientRect();
          const itemRect = activeTab.getBoundingClientRect();
          const currentScrollLeft = scrollContainer.scrollLeft;
          const rawScrollLeft = currentScrollLeft + (itemRect.left - containerRect.left) - ((scrollContainer.clientWidth - itemRect.width) / 2);
          const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
          const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

          if (typeof scrollContainer.scrollTo === 'function') {
            scrollContainer.scrollTo({
              left: nextScrollLeft,
              behavior: behavior,
            });
          } else {
            scrollContainer.scrollLeft = nextScrollLeft;
          }
        }
      }

      updateOverflowState() {
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollContainer) {
          return;
        }

        scrollContainer.classList.toggle('is-overflowing', this.isTabsOverflowing());
      }

      pauseAllVideos() {
        this.querySelectorAll('.yg-tabs-03__media-slide yg-video').forEach((videoElement) => {
          if (typeof videoElement.pauseVideo === 'function') {
            videoElement.pauseVideo();
          }
        });
      }

      playActiveVideo() {
        this.pauseAllVideos();

        const activeSlide = this.querySelector(`.yg-tabs-03__media-slide[data-slide-index="${this.activeIndex}"]`);
        const activeVideo = activeSlide?.querySelector('yg-video');

        if (activeVideo && typeof activeVideo.playVideo === 'function') {
          activeVideo.playVideo();
        }
      }

      setActiveState(index, options = {}) {
        const maxIndex = Math.max(this.sectionElements.contentSlides.length - 1, 0);
        const safeIndex = Math.max(0, Math.min(index, maxIndex));
        const syncSwiper = options.syncSwiper !== false;
        const scrollBehavior = options.scrollBehavior || 'smooth';

        this.activeIndex = safeIndex;

        if (syncSwiper) {
          if (this.mediaSwiper && this.mediaSwiper.activeIndex !== safeIndex) {
            this.mediaSwiper.slideTo(safeIndex);
          }

          if (this.contentSwiper && this.contentSwiper.activeIndex !== safeIndex) {
            this.contentSwiper.slideTo(safeIndex);
          }
        }

        this.sectionElements.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === safeIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.sectionElements.contentSlides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === safeIndex ? 'false' : 'true');
        });

        this.updateOverflowState();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView(scrollBehavior);
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        this.playActiveVideo();

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }
    }

    if (!window.customElements.get('yg-tabs-03')) {
      window.customElements.define('yg-tabs-03', YGTabs03);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-version-list"] && !Shopify.designMode) return;
  try {
    
  class YGVersionList extends HTMLElement {
    constructor() {
      super();
      this.handleSeeMoreClick = this.handleSeeMoreClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('[data-see-more-button]');
      this.buttonLabel = this.querySelector('[data-see-more-label]');
      this.collapsedRows = Array.from(this.querySelectorAll('[data-collapsed-row]'));

      if (!this.button || !this.collapsedRows.length) return;

      this.button.addEventListener('click', this.handleSeeMoreClick);
    }

    disconnectedCallback() {
      if (!this.button) return;

      this.button.removeEventListener('click', this.handleSeeMoreClick);
    }

    handleSeeMoreClick() {
      const isExpanded = this.button.getAttribute('aria-expanded') === 'true';

      this.collapsedRows.forEach((row) => {
        row.hidden = isExpanded;
      });

      this.button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      this.button.classList.toggle('active', !isExpanded);

      if (this.buttonLabel) {
        this.buttonLabel.textContent = isExpanded ? this.button.dataset.moreLabel : this.button.dataset.lessLabel;
      }
    }
  }

  if (!window.customElements.get('yg-version-list')) {
    window.customElements.define('yg-version-list', YGVersionList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-tabs"] && !Shopify.designMode) return;
  try {
    
  class YGVideoTabs extends HTMLElement {
    constructor() {
      super();
      this.currentTabKey = 'all';
      this.currentPage = 1;
      this.itemsPerPage = 1;
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    get sectionElements() {
      if (this._sectionElements) {
        return this._sectionElements;
      }

      this._sectionElements = {
        cardsPanel: this.querySelector('[data-cards]'),
        cards: Array.from(this.querySelectorAll('[data-card]')),
        pagination: this.querySelector('[data-pagination]'),
        paginationPages: this.querySelector('[data-pagination-pages]'),
        paginationPrev: this.querySelector('[data-page-action="prev"]'),
        paginationNext: this.querySelector('[data-page-action="next"]'),
        tabButtons: Array.from(this.querySelectorAll('[data-tab-button]')),
        tabTrack: this.querySelector('[data-tabs-track]'),
        tabsScroll: this.querySelector('[data-tabs-scroll]'),
      };

      return this._sectionElements;
    }

    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;
      this.itemsPerPage = this.getItemsPerPage();

      this.addEventListener('click', this.handleClick);
      this.sectionElements.tabTrack?.addEventListener('keydown', this.handleKeydown);
      window.addEventListener('resize', this.handleResize);

      this.updateTabsOverflow();
      this.filterAndPaginate();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.sectionElements.tabTrack?.removeEventListener('keydown', this.handleKeydown);
      window.removeEventListener('resize', this.handleResize);
      this.initialized = false;
    }

    getItemsPerPage() {
      const desktopItemsPerPage = Number.parseInt(this.dataset.itemsPerPage || '9', 10);
      const mobileItemsPerPage = Number.parseInt(this.dataset.itemsPerPageMobile || '4', 10);

      if (window.matchMedia('(max-width: 699px)').matches) {
        return mobileItemsPerPage;
      }

      return desktopItemsPerPage;
    }

    handleClick(event) {
      const tabButton = event.target.closest('[data-tab-button]');
      if (tabButton && this.contains(tabButton)) {
        this.setTab(tabButton.dataset.tabKey || 'all');
        return;
      }

      const pageButton = event.target.closest('[data-page-button]');
      if (pageButton && this.contains(pageButton)) {
        const page = Number.parseInt(pageButton.dataset.pageButton || '1', 10);
        this.setPage(page);
        return;
      }

      const pageActionButton = event.target.closest('[data-page-action]');
      if (pageActionButton && this.contains(pageActionButton)) {
        if (pageActionButton.dataset.pageAction === 'prev') {
          this.setPage(this.currentPage - 1);
        } else {
          this.setPage(this.currentPage + 1);
        }
      }
    }

    handleKeydown(event) {
      const activeIndex = this.sectionElements.tabButtons.findIndex((button) => button.dataset.tabKey === this.currentTabKey);
      let nextIndex = activeIndex;

      if (event.key === 'ArrowRight') {
        nextIndex = Math.min(activeIndex + 1, this.sectionElements.tabButtons.length - 1);
      } else if (event.key === 'ArrowLeft') {
        nextIndex = Math.max(activeIndex - 1, 0);
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.sectionElements.tabButtons.length - 1;
      } else {
        return;
      }

      event.preventDefault();

      const nextButton = this.sectionElements.tabButtons[nextIndex];
      if (!nextButton) {
        return;
      }

      this.setTab(nextButton.dataset.tabKey || 'all', {
        shouldFocus: true,
      });
    }

    handleResize() {
      const nextItemsPerPage = this.getItemsPerPage();
      if (nextItemsPerPage !== this.itemsPerPage) {
        this.itemsPerPage = nextItemsPerPage;
        this.currentPage = 1;
        this.filterAndPaginate();
      }

      this.updateTabsOverflow();
    }

    setTab(tabKey, options = {}) {
      const normalizedTabKey = tabKey || 'all';
      const shouldFocus = options.shouldFocus || false;

      if (normalizedTabKey === this.currentTabKey && !shouldFocus) {
        return;
      }

      this.currentTabKey = normalizedTabKey;
      this.currentPage = 1;
      this.updateTabButtons();
      this.filterAndPaginate();
      this.scrollActiveTabIntoView();

      if (shouldFocus) {
        const activeButton = this.sectionElements.tabButtons.find((button) => button.dataset.tabKey === this.currentTabKey);
        activeButton?.focus();
      }
    }

    setPage(page) {
      const nextPage = Math.max(1, page);
      if (nextPage === this.currentPage) {
        return;
      }

      this.currentPage = nextPage;
      this.filterAndPaginate();
      this.scrollCardsIntoView();
    }

    updateTabButtons() {
      this.sectionElements.tabButtons.forEach((button) => {
        const isActive = (button.dataset.tabKey || 'all') === this.currentTabKey;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    updateTabsOverflow() {
      const tabsScroll = this.sectionElements.tabsScroll;
      const tabTrack = this.sectionElements.tabTrack;

      if (!tabsScroll || !tabTrack) {
        return;
      }

      tabsScroll.classList.toggle('is-overflowing', tabTrack.scrollWidth > tabsScroll.clientWidth + 1);
    }

    scrollActiveTabIntoView() {
      const activeButton = this.sectionElements.tabButtons.find((button) => button.dataset.tabKey === this.currentTabKey);
      activeButton?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }

    scrollCardsIntoView() {
      this.sectionElements.cardsPanel?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }

    filterAndPaginate() {
      const filteredCards = this.sectionElements.cards.filter((card) => {
        if (this.currentTabKey === 'all') {
          return true;
        }

        return (card.dataset.tabKey || '') === this.currentTabKey;
      });

      const totalPages = Math.max(1, Math.ceil(filteredCards.length / this.itemsPerPage));
      if (this.currentPage > totalPages) {
        this.currentPage = totalPages;
      }

      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      const visibleCards = filteredCards.slice(startIndex, endIndex);
      const visibleCardsSet = new Set(visibleCards);

      this.sectionElements.cards.forEach((card) => {
        const isVisible = visibleCardsSet.has(card);
        card.hidden = !isVisible;
        card.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      });

      this.renderPagination(totalPages);
    }

    renderPagination(totalPages) {
      const { pagination, paginationPages, paginationPrev, paginationNext } = this.sectionElements;

      if (!pagination || !paginationPages || !paginationPrev || !paginationNext) {
        return;
      }

      pagination.hidden = totalPages <= 1;
      paginationPrev.disabled = this.currentPage === 1;
      paginationNext.disabled = this.currentPage === totalPages;
      paginationPages.innerHTML = '';

      for (let page = 1; page <= totalPages; page += 1) {
        const pageButton = document.createElement('button');
        pageButton.type = 'button';
        pageButton.className = 'yg-video-tabs__page radius-xs text-sm bold';
        pageButton.dataset.pageButton = String(page);
        pageButton.textContent = String(page);

        if (page === this.currentPage) {
          pageButton.classList.add('is-active');
          pageButton.setAttribute('aria-current', 'page');
        }

        paginationPages.appendChild(pageButton);
      }
    }
  }

  if (!window.customElements.get('yg-video-tabs')) {
    window.customElements.define('yg-video-tabs', YGVideoTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
